// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js","765":"component---src-pages-index-copy-js"}[chunkId] || chunkId) + "-" + {"125":"00a4864f66c5b936310a","293":"f865c017f29d6c027f7a","522":"949e4685cc0363756fc8","765":"bf717b888f9572d5a8af"}[chunkId] + ".js";
};